import React from "react";
import { Chip, Tooltip } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";

/**
 * Marks an order whose billed party is a reseller rather than the end customer. The reseller's own
 * legal name is a tooltip, because a list row has no width to spend on a second account name.
 *
 * The prototype paints this pill purple, and the admin theme has no purple: its palette carries
 * primary, secondary, error, the status colours and the text and action greys. A colour would also
 * be the wrong signal - being sold through a reseller is a plain fact about the order, not a warning
 * about it - so this follows `ResellerChip` on the billing accounts screen and stays uncoloured.
 * @param root0
 * @param root0.resellerLegalName
 * @param root0.sx
 */
export function ViaResellerBadge({ resellerLegalName, sx }: { resellerLegalName?: string; sx?: SxProps<Theme> }) {
  return (
    // An empty title renders no tooltip, which is what an unresolved reseller name should do.
    <Tooltip title={resellerLegalName ?? ""}>
      <Chip label="Via reseller" size="small" variant="outlined" sx={sx} />
    </Tooltip>
  );
}
